import { render, staticRenderFns } from "./PageEventABCBookChapters.vue?vue&type=template&id=21dea8a9&scoped=true&"
import script from "./PageEventABCBookChapters.vue?vue&type=script&lang=js&"
export * from "./PageEventABCBookChapters.vue?vue&type=script&lang=js&"
import style0 from "./PageEventABCBookChapters.vue?vue&type=style&index=0&id=21dea8a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dea8a9",
  null
  
)

export default component.exports